export const CC_MODERATION_USER_JOINED =
  "CCMODERATION::CC_MODERATION_USER_JOINED";
export const CC_STATUS_CHANGED = "CCMODERATION::CC_STATUS_CHANGED";
export const CC_MODERATION_USER_LEFT = "CCMODERATION::CC_MODERATION_USER_LEFT";
